export default {
    setLoading(state, value) {
        state.loading = value;
    },
    incrementLoadingCount(state) {
        state.loadingCount++;
    },
    decrementLoadingCount(state) {
        state.loadingCount--;
    },
    setLoadingSpinnerDuration(state, value) {
        state.loadingSpinnerDuration = value;
    },
    setError(state, value) {
        state.error = value;
    },
    setErrors(state, value) {
        state.errors = value;
    },
    setErrorMessage(state, value) {
        state.errorMessage = value;
    },
    setContracts(state, value) {
        state.contracts = value;
    },
    setChecklists(state, value) {
        state.checklists = value;
    },
    setKlickmaluser(state, value) {
        state.klickmaluser = value;
    },
    setUserdetails(state, value) {
        state.userdetails = value;
    },
    setIsLoggedIn(state, value) {
        state.isLoggedIn = value;
    },
    setBaseurl(state, value) {
        state.baseurl = value;
    },
    setGalleryIndex(state, value) {
        state.galleryIndex = value;
    },
    setGalleryToken(state, value) {
        state.galleryToken = value;
    },
    setResetSchadensmeldungFormData(state, value) {
        state.resetSchadensmeldungFormData = value;
    },
    setPushToken(state, value) {
        state.pushToken = value;
    },
    setAskForRating(state, value) {
        state.askForRating = value;
    },
    setShowTabBar(state, value) {
        state.showTabBar = value;
    },
    setNativeEnvironment(state, value) {
        state.nativeEnvironment = value;
    },
    addDevelopmentLog(state, value) {
        state.developmentLogs.push(value);
    },
    setAfterLoginLink(state, value) {
        state.afterLoginLink = value;
    },
};
